import React from 'react';
import MediaBuyingReportPanel from './MediaBuyingReport';

// Re-export the refactored component
export default MediaBuyingReportPanel; 